import { useBookingContext } from '../../contexts/BookingContext';
import { useDateStepper } from '../../hooks/useDateStepper';
import { TimeSlotEntry } from '../../types/booking';
import Calendar from '../molecules/Calendar';
import Stepper from '../molecules/Stepper';

interface DateSelectionProps {
	selectedDate: string;
	timeSlots: TimeSlotEntry[];
	getLabel: (key: string) => string;
	setSelectedDate: (date: string) => void;
}

export default function DateSelection({ timeSlots, getLabel, selectedDate, setSelectedDate }: DateSelectionProps) {
	const { locale } = useBookingContext();
	const {
		hasNextDayAvailability,
		hasNextMonthAvailability,
		hasPreviousDayAvailability,
		hasPreviousMonthAvailability,
		month,
		nextDay,
		nextMonth,
		previousDay,
		previousMonth,
		year,
	} = useDateStepper(selectedDate, setSelectedDate, timeSlots);

	return (
		<div className="booking__date-selection">
			{/* Step through dates */}
			<Stepper
				id="date-stepper"
				allowPreviousStep={hasPreviousDayAvailability}
				allowNextStep={hasNextDayAvailability}
				isCurrentValue={false}
				stepBackward={previousDay}
				stepForward={nextDay}
				stepBackwardTitle={getLabel('date_selection_previous_day')}
				stepForwardTitle={getLabel('date_selection_next_day')}
			>
				{new Date(selectedDate).toLocaleString(locale, { weekday: 'short', day: '2-digit', month: 'long', year: 'numeric' })}
			</Stepper>

			{/* Step through months */}
			<Stepper
				id="month-stepper"
				allowPreviousStep={hasPreviousMonthAvailability}
				allowNextStep={hasNextMonthAvailability}
				isCurrentValue={year === new Date().getFullYear() && month === new Date().getMonth()}
				stepBackward={previousMonth}
				stepForward={nextMonth}
				stepBackwardTitle={getLabel('date_selection_previous_month')}
				stepForwardTitle={getLabel('date_selection_next_month')}
			>
				{new Date(year, month).toLocaleString(locale, { month: 'long', year: 'numeric' })}
			</Stepper>

			<Calendar month={month} selectedDate={selectedDate} setSelectedDate={setSelectedDate} year={year} />
		</div>
	);
}
